module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-19-190ada373d97454068446af1e5f0f256.jpg";